// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Container styling */
.btnSection {
    display: flex;
    gap: 10px; /* Space between the buttons */
    overflow: hidden;
    margin-top: 20px;
}

/* Button styling */
.btnSection button {
    padding: 10px 20px;
    font-size: 16px;
    color: white;
    /* background-color: #007bff;  */
    background-color: #006600;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.btnSection button:hover {
    /* background-color: #0056b3;  */
    background-color: #218838; /* Darker shade on hover 
    transform: scale(1.05); /* Slightly enlarges the button on hover */
}

.btnSection button:active {
    transform: scale(0.95); /* Slightly shrinks the button on click */
}

.btnSection button:nth-child(2) {
    /* background-color: #006600; */
    background-color: #007bff; 
    /* background-color: #28a745;  */
}

.btnSection button:nth-child(2):hover {
    /* background-color: #218838; */
    background-color: #0056b3;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .btnSection {
        flex-direction: column;
        align-items: stretch;
    }

    .btnSection button {
        width: 100%;
        text-align: center;
    }
}

.Timeline{
    background-color: black;
}


.CourseSpotCover{
    position: relative;
    width: 100%;
   
}

.courseoverviewnew{
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 20px 0;
}

.fontAweTick{
    text-decoration: none;
    color: #003300;
    font-size: 1.5rem;
    font-weight:bolder;
    margin-right: 20px;
}

.OpeningTag{
    padding-left: 30px;
}

.respectiveContentSection{

    display: flex;
    flex-wrap: wrap;
    width: 100%;
    background-color: #f7f7f7;
    justify-content: space-between;
    padding: 30px;
    gap: 30px;
    /* align-items: center; */

}

.ImageDescription{

   
    flex: 7 1;
    /* width: 60%; */
    min-width: 350px;
  

}

.ImageDescription .imgCover{

    position: relative;
    height: 300px;
    overflow: hidden;

}
.ImageDescription img{

    width: 100%;
    height: 100%;
    object-fit: cover;

}

.CardDescription{
    flex: 4 1;
    /* background-color: green; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    /* margin-top: 30px; */
    /* background-color: red; */
    background-color: white;
    margin-bottom: 30px;
    min-width: 400px;
}
.CardDescription button{
  background-color: #003300;
  width: 100px;
  /* padding: 3px; */
  align-items: center;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.CardDescription button:hover{
  background-color: black;

}
.CardDescriptionCover{
    width: 400px;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;
    align-items: center;
   /* margin-top: 20px; */
}
.CardDescriptionCover .LinkItems h3{
   color: white;
   /* background-color: red; */
}
.CardDescriptionCover .LinkItems button{
   color: white;
   /* background-color: red; */
}
.SquareCards{
    position: relative;
    /* background-color: yellow; */
    padding: 10px;
}
.SquareCards h1,p{

    /* color: white; */
   
}

.FirstSquareCards{
    color: white;
}

.SecondSquareCardsff{
    color: white;
}

.respectivecard{
    width: 200px;
    /* background-color: rgb(137, 148, 134); */
    background-color: #003300;
}

.FirstSquareCards{
    display: flex;
    margin-bottom: 5px;
    gap: 5px;

} 
.SecondSquareCardsff{
    display: flex;
    gap: 5px;
} 


/* KEY CONCEPTS CSS */

.CourseResources{
    /* background-color: #f7f7f7; */
}

.courseResPointsContCover{
    display: flex;
    justify-content: space-around;
    /* max-width: 700px;
    min-width: 450px; */
}

.respectivePoint{
    display: flex;
    align-items: center;
    max-width: 500px;
    min-width: 400px;
}



/* LECTURER SPOT */

.CourseSpotLectuerCover{
    background-color: #f7f7f7;
    padding: 30px;
    font-size: 15px;
    
}
.CourseSpotLectuerCover h3{
 
    margin: 0;
    padding: 0;
    
}

.LecturerSpotCardCover{
    display: flex;
    justify-content: space-around;
}

.LecturerSpotCard{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 450px;
    min-width: 450px;
    margin-top: 30px;
}

.LecturerSpotImage{
    border-radius: 50%;
    margin-bottom: 10px;

}

.CourseSpotLectuerCover img{
   
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    overflow: hidden;
}


/* ELIGIBILTY START */

.ElgibilityCover{

    background-color: #003300;
    padding: 30px;

    
}

.EligibiityContainer{

    display: flex;
    justify-content: space-around;
}

.EligibiityCard{
    
     width: 300px;
     background-color: white;
     text-align: center;
     padding: 40px 20px;
     border-radius: 3px;
}
.EligibiityCard h3{
    
    padding: 0;
    margin: 0;
}
.EligibiityCard .Starting p{
    
    padding: 0;
    margin: 0;
    color: gray;
}
.EligibiityCard .ApplyNowCTA button{
     
    border: none;
    background-color: #014401;
    color: white;
    padding: 12px 24px;
    border-radius: 3px;
    cursor: pointer;
    
}
.EligibiityCard .PriceAndDuration{
     
    display: flex;
    /* justify-content: space-around; */
    justify-content: center;
    gap: 10px;
    
}
.EligibiityCard .ApplyNowCTA button:hover{
     
    border: none;
    background-color: black;
    color: white;
    padding: 12px 24px;
    border-radius: 3px;
    cursor: pointer;
    
}


@media screen and (max-width: 730px){     

        .CardDescription{
            flex: 4 1;
            /* background-color: green; */
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            /* margin-top: 30px; */
            /* background-color: red; */
            background-color: white;
            margin-bottom: 30px;
            min-width: 350px;
        }

        .CardDescriptionCover{
            width: 350px;
            background-color: white;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            text-align: center;
            align-items: center;
           /* margin-top: 20px; */
        }

        .respectiveContentSection{
            /* background-color: yellow; */
            flex-direction: column;
        }

        .respectiveContentSection{

         
            padding: 5px;
           
        
        }

  
   }
  `, "",{"version":3,"sources":["webpack://./src/Components/CourseSpot/CourseSpot.css"],"names":[],"mappings":";;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,SAAS,EAAE,8BAA8B;IACzC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gCAAgC;IAChC,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,gCAAgC;IAChC,yBAAyB,EAAE;sEACuC;AACtE;;AAEA;IACI,sBAAsB,EAAE,yCAAyC;AACrE;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,SAAS;IACT,yBAAyB;;AAE7B;;AAEA;;;IAGI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;;;AAGpB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;;AAEpB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;IACI,SAAO;IACP,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,uBAAuB;;AAEzB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;GACpB,sBAAsB;AACzB;AACA;GACG,YAAY;GACZ,2BAA2B;AAC9B;AACA;GACG,YAAY;GACZ,2BAA2B;AAC9B;AACA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;AACjB;AACA;;IAEI,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;;AAEZ;AACA;IACI,aAAa;IACb,QAAQ;AACZ;;;AAGA,qBAAqB;;AAErB;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B;uBACmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA,kBAAkB;;AAElB;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;;AAEnB;AACA;;IAEI,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA,qBAAqB;;AAErB;;IAEI,yBAAyB;IACzB,aAAa;;;AAGjB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;AACjC;;AAEA;;KAEK,YAAY;KACZ,uBAAuB;KACvB,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;AACvB;AACA;;IAEI,UAAU;IACV,SAAS;AACb;AACA;;IAEI,UAAU;IACV,SAAS;IACT,WAAW;AACf;AACA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;;AAEnB;AACA;;IAEI,aAAa;IACb,mCAAmC;IACnC,uBAAuB;IACvB,SAAS;;AAEb;AACA;;IAEI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;;AAEnB;;;AAGA;;QAEQ;YACI,SAAO;YACP,6BAA6B;YAC7B,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,6BAA6B;YAC7B,sBAAsB;YACtB,2BAA2B;YAC3B,uBAAuB;YACvB,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA;YACI,YAAY;YACZ,uBAAuB;YACvB,aAAa;YACb,sBAAsB;YACtB,6BAA6B;YAC7B,kBAAkB;YAClB,mBAAmB;WACpB,sBAAsB;QACzB;;QAEA;YACI,8BAA8B;YAC9B,sBAAsB;QAC1B;;QAEA;;;YAGI,YAAY;;;QAGhB;;;GAGL","sourcesContent":["\n\n/* Container styling */\n.btnSection {\n    display: flex;\n    gap: 10px; /* Space between the buttons */\n    overflow: hidden;\n    margin-top: 20px;\n}\n\n/* Button styling */\n.btnSection button {\n    padding: 10px 20px;\n    font-size: 16px;\n    color: white;\n    /* background-color: #007bff;  */\n    background-color: #006600;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.btnSection button:hover {\n    /* background-color: #0056b3;  */\n    background-color: #218838; /* Darker shade on hover \n    transform: scale(1.05); /* Slightly enlarges the button on hover */\n}\n\n.btnSection button:active {\n    transform: scale(0.95); /* Slightly shrinks the button on click */\n}\n\n.btnSection button:nth-child(2) {\n    /* background-color: #006600; */\n    background-color: #007bff; \n    /* background-color: #28a745;  */\n}\n\n.btnSection button:nth-child(2):hover {\n    /* background-color: #218838; */\n    background-color: #0056b3;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .btnSection {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .btnSection button {\n        width: 100%;\n        text-align: center;\n    }\n}\n\n.Timeline{\n    background-color: black;\n}\n\n\n.CourseSpotCover{\n    position: relative;\n    width: 100%;\n   \n}\n\n.courseoverviewnew{\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    margin: 20px 0;\n}\n\n.fontAweTick{\n    text-decoration: none;\n    color: #003300;\n    font-size: 1.5rem;\n    font-weight:bolder;\n    margin-right: 20px;\n}\n\n.OpeningTag{\n    padding-left: 30px;\n}\n\n.respectiveContentSection{\n\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    background-color: #f7f7f7;\n    justify-content: space-between;\n    padding: 30px;\n    gap: 30px;\n    /* align-items: center; */\n\n}\n\n.ImageDescription{\n\n   \n    flex: 7;\n    /* width: 60%; */\n    min-width: 350px;\n  \n\n}\n\n.ImageDescription .imgCover{\n\n    position: relative;\n    height: 300px;\n    overflow: hidden;\n\n}\n.ImageDescription img{\n\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n\n}\n\n.CardDescription{\n    flex: 4;\n    /* background-color: green; */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    /* margin-top: 30px; */\n    /* background-color: red; */\n    background-color: white;\n    margin-bottom: 30px;\n    min-width: 400px;\n}\n.CardDescription button{\n  background-color: #003300;\n  width: 100px;\n  /* padding: 3px; */\n  align-items: center;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.CardDescription button:hover{\n  background-color: black;\n\n}\n.CardDescriptionCover{\n    width: 400px;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    text-align: center;\n    align-items: center;\n   /* margin-top: 20px; */\n}\n.CardDescriptionCover .LinkItems h3{\n   color: white;\n   /* background-color: red; */\n}\n.CardDescriptionCover .LinkItems button{\n   color: white;\n   /* background-color: red; */\n}\n.SquareCards{\n    position: relative;\n    /* background-color: yellow; */\n    padding: 10px;\n}\n.SquareCards h1,p{\n\n    /* color: white; */\n   \n}\n\n.FirstSquareCards{\n    color: white;\n}\n\n.SecondSquareCardsff{\n    color: white;\n}\n\n.respectivecard{\n    width: 200px;\n    /* background-color: rgb(137, 148, 134); */\n    background-color: #003300;\n}\n\n.FirstSquareCards{\n    display: flex;\n    margin-bottom: 5px;\n    gap: 5px;\n\n} \n.SecondSquareCardsff{\n    display: flex;\n    gap: 5px;\n} \n\n\n/* KEY CONCEPTS CSS */\n\n.CourseResources{\n    /* background-color: #f7f7f7; */\n}\n\n.courseResPointsContCover{\n    display: flex;\n    justify-content: space-around;\n    /* max-width: 700px;\n    min-width: 450px; */\n}\n\n.respectivePoint{\n    display: flex;\n    align-items: center;\n    max-width: 500px;\n    min-width: 400px;\n}\n\n\n\n/* LECTURER SPOT */\n\n.CourseSpotLectuerCover{\n    background-color: #f7f7f7;\n    padding: 30px;\n    font-size: 15px;\n    \n}\n.CourseSpotLectuerCover h3{\n \n    margin: 0;\n    padding: 0;\n    \n}\n\n.LecturerSpotCardCover{\n    display: flex;\n    justify-content: space-around;\n}\n\n.LecturerSpotCard{\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    max-width: 450px;\n    min-width: 450px;\n    margin-top: 30px;\n}\n\n.LecturerSpotImage{\n    border-radius: 50%;\n    margin-bottom: 10px;\n\n}\n\n.CourseSpotLectuerCover img{\n   \n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    object-fit: cover;\n    overflow: hidden;\n}\n\n\n/* ELIGIBILTY START */\n\n.ElgibilityCover{\n\n    background-color: #003300;\n    padding: 30px;\n\n    \n}\n\n.EligibiityContainer{\n\n    display: flex;\n    justify-content: space-around;\n}\n\n.EligibiityCard{\n    \n     width: 300px;\n     background-color: white;\n     text-align: center;\n     padding: 40px 20px;\n     border-radius: 3px;\n}\n.EligibiityCard h3{\n    \n    padding: 0;\n    margin: 0;\n}\n.EligibiityCard .Starting p{\n    \n    padding: 0;\n    margin: 0;\n    color: gray;\n}\n.EligibiityCard .ApplyNowCTA button{\n     \n    border: none;\n    background-color: #014401;\n    color: white;\n    padding: 12px 24px;\n    border-radius: 3px;\n    cursor: pointer;\n    \n}\n.EligibiityCard .PriceAndDuration{\n     \n    display: flex;\n    /* justify-content: space-around; */\n    justify-content: center;\n    gap: 10px;\n    \n}\n.EligibiityCard .ApplyNowCTA button:hover{\n     \n    border: none;\n    background-color: black;\n    color: white;\n    padding: 12px 24px;\n    border-radius: 3px;\n    cursor: pointer;\n    \n}\n\n\n@media screen and (max-width: 730px){     \n\n        .CardDescription{\n            flex: 4;\n            /* background-color: green; */\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: space-around;\n            /* margin-top: 30px; */\n            /* background-color: red; */\n            background-color: white;\n            margin-bottom: 30px;\n            min-width: 350px;\n        }\n\n        .CardDescriptionCover{\n            width: 350px;\n            background-color: white;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-around;\n            text-align: center;\n            align-items: center;\n           /* margin-top: 20px; */\n        }\n\n        .respectiveContentSection{\n            /* background-color: yellow; */\n            flex-direction: column;\n        }\n\n        .respectiveContentSection{\n\n         \n            padding: 5px;\n           \n        \n        }\n\n  \n   }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
